import React, { useEffect, useRef, useState } from "react";
import { IoMdSend } from "react-icons/io";
import { RxReset } from "react-icons/rx";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { marked } from "marked";
import { GetFilesPreview } from "../../../../apis";
import { TbSourceCode, TbWorldWww } from "react-icons/tb";
import { IoClose, IoDocumentTextOutline } from "react-icons/io5";
import { BsFileEarmarkPdfFill } from "react-icons/bs";
import { ImSpinner2 } from "react-icons/im";
import { RiRobot2Line, RiLoaderLine } from "react-icons/ri";

const DemoChat = ({ state }) => {
  const textRef = useRef(null);
  const [msgg, setmsgg] = useState([]);
  const [prevBotId, setPrevBotId] = useState(null);
  const [que, setQue] = useState("");
  const [load, setLoad] = useState(false);
  const [context, setContext] = useState([]);
  const [showcontext, setShowcontext] = useState(false);

  const user = useSelector((sta) => sta.user.user);
  const userId = user?.userId;
  // Load messages when selected bot changes
  useEffect(() => {
    const newBotId = state.selectedBot?.botId;

    if (!newBotId) return;

    // Save previous bot's messages
    if (prevBotId && prevBotId !== newBotId) {
      localStorage.setItem(prevBotId, JSON.stringify(msgg));
    }

    // Load messages for the new bot
    const stored = localStorage.getItem(newBotId);
    if (stored) {
      setmsgg(JSON.parse(stored));
    } else {
      // Initial message for a new bot
      setmsgg([
        {
          isbot: true,
          msgg: "Hi, I am an AI assistant. I can help you find information on this website. Ask me your queries!",
          key: uuidv4(),
          load: false,
        },
      ]);
    }

    setPrevBotId(newBotId);
  }, [state.selectedBot?.botId]);

  // Save on message change (if there's an active bot)
  useEffect(() => {
    const botId = state.selectedBot?.botId;
    if (botId) {
      localStorage.setItem(botId, JSON.stringify(msgg));
    }

    const container = document.getElementById("containerRef");
    if (container && msgg?.length > 0) {
      const lastmsgg = msgg[msgg?.length - 1]; // Get the last message
      if (!lastmsgg?.isbot) {
        container.scrollTop = container.scrollHeight; // Scroll to the bottom
      }
    }
  }, [msgg]);

  const handleInput = () => {
    const textarea = textRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${Math.min(textarea.scrollHeight, 150)}px`;
    }
  };

  const handleReset = () => {
    setmsgg([
      {
        isbot: true,
        msgg: "Hi, I am an AI assistant. I can help you find information on this website. Ask me your queries!",
        key: uuidv4(),
        load: false,
      },
    ]);
  };

  const handleSend = async () => {
    console.log("userId: ", userId);
    setQue("");
    setLoad(true);
    const container = document.getElementById("containerRef");
    container.scrollTop = container.scrollHeight + 10000;
    if (que.trimStart().trimEnd() === "") {
      setLoad(false);
      return null;
    }

    // Update existing message block with the user input
    const key = uuidv4();
    setmsgg((prevmsgg) => [
      ...prevmsgg,
      { isbot: false, msgg: que, key: key, load: false },
    ]);

    container.scrollTop = container.scrollHeight;
    const anskey = uuidv4();
    const uri = `${process.env.REACT_APP_CHAT_API}/botquery/${userId}/${
      state.selectedBot?.botId
    }?reranking=${true}&queryexpanstion=${false}`;

    const premsgg = msgg?.slice(-4, -1).reduce((acc, item) => {
      return item?.isbot
        ? acc + `Answer: ${item.msgg}\n`
        : acc + `Question: ${item.msgg}\n`;
    }, "");

    // container.scrollTop = container.scrollHeight + 10000;

    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        que: `${que.trimStart().trimEnd()}`,
        email: que?.email,
        name: "admin",
        phone: "0000000000",
        premsgg: premsgg || "",
      }),
    };

    try {
      setmsgg((prevmsgg) => [
        ...prevmsgg,
        {
          isbot: true,
          msgg: "",
          key: anskey,
          loading: true,
          citation: [],
          uid: null,
        },
      ]);

      const res = await fetch(uri, option);
      const reader = res.body.getReader();
      let decoder = new TextDecoder();
      let result = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          break;
        }
        result += decoder.decode(value);
        const ptext = document.getElementById(`p_${anskey}`);
        ptext.innerHTML = marked.parse(result);
        container.scrollTop = container.scrollHeight;
      }

      const ptext = document.getElementById(`p_${anskey}`);
      const citation = res.headers.get("doc_keys");
      const decoded_citation = atob(citation);
      const uid = res.headers.get("uid");
      const loader = document.getElementById(`${anskey}-loader`);
      loader.style.display = "none";
      const citation_list = [];

      if (citation) {
        let listOfCitation = JSON.parse(decoded_citation);

        const uniqueLinks = [
          ...new Set(listOfCitation.map((link) => link.url)),
        ];

        listOfCitation = listOfCitation?.filter((ele) => {
          const index = uniqueLinks?.indexOf(ele.url);
          if (index !== -1) {
            // Remove the used link from uniqueLinks
            uniqueLinks?.splice(index, 1);
            return true; // Keep this element in the filtered list
          }
          return false; // Exclude the element if the link has already been used
        });

        listOfCitation.forEach(async (item) => {
          const sub_type = item?.sub_type;
          if (sub_type === "web") {
            citation_list.push({ uri: item?.url, type: item?.file_type });
          }
          if (sub_type === "s3") {
            const signedUrl = await GetFilesPreview(item?.url);
            if (!signedUrl.error)
              citation_list.push({
                uri: signedUrl.data,
                type: item?.file_type,
              });
          }
        });
      }

      setmsgg((prev) => [
        ...prev.slice(0, -1),
        {
          isbot: true,
          msgg: ptext.innerHTML,
          key: anskey,
          loading: false,
          citation: citation_list,
          uid: uid,
        },
      ]);

      if (uid) {
        const ans = document.getElementById(`p_${anskey}`).textContent;
        const urii = `${process.env.REACT_APP_CHAT_API}/answer/${uid}`;
        const option = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ans: ans }),
        };
        await fetch(urii, option);
      }

      setLoad(false);
    } catch (error) {
      console.error("Error fetching response:", error);
      setLoad(false);
    }
  };

  const handelcontext = async (e, id) => {
    if (id === null) {
      return;
    }
    console.log("id", id);
    e.preventDefault();

    const uri = `${process.env.REACT_APP_CHAT_API}/context/${id}`;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await fetch(uri, options);
    if (res.ok) {
      const data = await res.json();
      setContext(data?.chunks);
    } else {
      setContext([]);
    }
    setShowcontext(!showcontext);
  };

  return (
    <>
      <div className="flex flex-1 flex-col h-96 sticky top-28 mt-3">
        {/* Chat Header */}
        <div className="z-20 bg-white p-4 shadow-sm border rounded-t-md flex justify-between items-center">
          <span className="text-lg font-semibold text-gray-800">Chat Now</span>
          <button
            title="Reset"
            onClick={handleReset}
            className="p-2 rounded hover:bg-gray-100 transition">
            <RxReset size={20} className="text-gray-700" />
          </button>
        </div>

        {/* Chat Body */}
        <div className="flex-1 relative overflow-y-auto bg-white border-x border-b rounded-b-md p-4 space-y-3">
          <div
            id="containerRef"
            className="absolute inset-0 overflow-y-auto my-2 w-full pr-1">
            {msgg.map((message, index) => (
              <div
                key={message.key || index}
                id={message.key}
                className={`flex ${
                  message.isbot ? "justify-start" : "justify-end"
                } mb-3`}>
                <div
                  className={`max-w-[97%] flex gap-2 items-end ${
                    message.isbot ? "flex-row" : "flex-row-reverse"
                  }`}>
                  {message.isbot ? (
                    <div className="flex flex-col gap-2 max-w-[94%] p-2 px-3 bg-slate-100 rounded-xl rounded-tl-none shadow-sm">
                      <div className="flex items-start gap-2">
                        <div
                          id={`p_${message?.key}`}
                          className="text-sm text-gray-800"
                          dangerouslySetInnerHTML={{ __html: message?.msgg }}
                        />
                      </div>

                      {/* Citations */}
                      {message?.citation?.length > 0 && (
                        <div className="mt-2 text-sm space-y-1">
                          <div className="border-t pt-2 font-semibold text-gray-800">
                            Reference Link
                          </div>
                          {message.citation.map((item, index) => (
                            <div
                              key={index}
                              className="flex items-start gap-2 break-all">
                              {item?.type === "pdf" && (
                                <BsFileEarmarkPdfFill className="min-w-4 mt-1  min-h-4" />
                              )}
                              {item?.type === "text" && (
                                <IoDocumentTextOutline className="min-w-4 mt-1 min-h-4" />
                              )}
                              {item?.type === "html" && (
                                <TbWorldWww className="min-w-4 mt-1 min-h-4" />
                              )}
                              <a
                                href={item?.uri}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:underline break-words">
                                {item.type === "html"
                                  ? `${item.uri.slice(0, 100)}${
                                      item.uri.length > 100 ? "..." : ""
                                    }`
                                  : (() => {
                                      const filename = decodeURIComponent(
                                        item.uri
                                          ?.split("?")[0]
                                          ?.split("/")
                                          .pop() || ""
                                      );
                                      return filename.length > 100
                                        ? filename.slice(0, 100) + "..."
                                        : filename;
                                    })()}
                              </a>
                            </div>
                          ))}
                        </div>
                      )}
                      {message?.loading && (
                        <RiLoaderLine
                          size={16}
                          id={`${message.key}-loader`}
                          className="animate-spin text-gray-500 mt-1"
                        />
                      )}

                      {/* Source Context Button */}
                      {message.uid && (
                        <div className="w-full flex justify-end items-center">
                          <button
                            onClick={(e) => handelcontext(e, message.uid)}
                            className="self-start ml-10 mt-2 p-1 bg-slate-50 rounded hover:bg-slate-200 transition">
                            <TbSourceCode className="w-5 h-5" />
                          </button>
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      <div className="p-3 bg-gray-200 rounded-lg text-sm text-gray-800 shadow">
                        {message.msgg}
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Chat Input */}
        <div className="relative flex items-center mt-2 border rounded-md shadow-md border-gray-200">
          <textarea
            ref={textRef}
            value={que}
            onChange={(e) => setQue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey && !load) {
                e.preventDefault();
                handleSend();
              }
            }}
            rows={1}
            placeholder="Type your message..."
            onInput={handleInput}
            className="w-full max-h-[150px] border-none outline-none resize-none p-2 pr-10 rounded-md text-sm focus:ring-1 focus:ring-blue-500"
          />
          {!load ? (
            <button
              title="Send"
              onClick={handleSend}
              className="absolute bottom-2 right-2 text-blue-600 hover:scale-110 transition-transform">
              <IoMdSend size={20} />
            </button>
          ) : (
            <ImSpinner2
              className="absolute bottom-2 right-2 text-blue-600 animate-spin"
              size={16}
            />
          )}
        </div>

        {/* Source Context Modal */}
      </div>
      {showcontext && (
        <div
          onClick={() => setShowcontext(false)}
          className="fixed z-50 top-0 left-0 font-mono bg-[rgba(0,0,0,0.7)] w-screen h-dvh flex justify-center items-center">
          <div
            onClick={(e) => e.stopPropagation()}
            className="max-h-[90vh] relative w-full sm:w-[600px] p-4 sm:p-6 md:p-8 bg-white rounded-lg overflow-y-auto shadow-xl">
            <button
              onClick={() => setShowcontext(false)}
              className="absolute right-2 top-2 p-1 bg-red-600 text-white rounded-full hover:bg-red-700">
              <IoClose className="w-5 h-5" />
            </button>
            <h4 className="text-lg font-semibold mb-4">Data Source</h4>
            <div className="space-y-4">
              {context?.map((ele, index) => (
                <div key={index} className="text-sm">
                  <div className="flex gap-2">
                    <span>{index + 1}.</span>
                    <p>{ele}</p>
                  </div>
                  <div className="mt-1 h-px bg-black"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DemoChat;
